import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { normalizeOperator } from '../../common/functions';
import { InsectaServiceBase } from './insecta.base.service';
import { ICountResult, IOrderApprovalSearchRequest, IOrderItemSearchRequest, ISearchResult } from './insecta.models';

@Injectable({
  providedIn: `root`
})
export class SearchService extends InsectaServiceBase {
  public orderItems(request: IOrderItemSearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => (filter.operator = normalizeOperator(filter.operator)));
    return this.post<ISearchResult>(`/search/orderitems`, `v1`, request);
  }

  public orderItemsCount(request: IOrderItemSearchRequest): Observable<ICountResult> {
    request.filters.forEach((filter) => (filter.operator = normalizeOperator(filter.operator)));
    return this.post<ISearchResult>(`/search/orderitems/count`, `v1`, request);
  }

  public orderApprovals(request: IOrderApprovalSearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => (filter.operator = normalizeOperator(filter.operator)));
    return this.post<ISearchResult>(`/search/approval`, `v1`, request);
  }

  public orderApprovalsCount(request: IOrderApprovalSearchRequest): Observable<ICountResult> {
    request.filters.forEach((filter) => (filter.operator = normalizeOperator(filter.operator)));
    return this.post<ISearchResult>(`/search/approval/count`, `v1`, request);
  }

  public orderItemInstances(request: IOrderItemSearchRequest): Observable<ISearchResult> {
    request.filters.forEach((filter) => (filter.operator = normalizeOperator(filter.operator)));
    return this.post<ISearchResult>(`/search/orderiteminstance`, `v1`, request);
  }

  public orderItemInstancesCount(request: IOrderItemSearchRequest): Observable<ICountResult> {
    request.filters.forEach((filter) => (filter.operator = normalizeOperator(filter.operator)));
    return this.post<ISearchResult>(`/search/orderiteminstance/count`, `v1`, request);
  }
}
